import { ValidatorRuleType } from "@tCooneyBrothers/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    billingPo: "",
    paymentMethodSelect: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
    // index: any;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const eventRegistrationValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
    },
    company: {
        required: true,
        minLength: 2,
        label: "Company",
    },
    phone: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Phone Number",
    },
    email: {
        required: true,
        regex: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        label: "Email Address",
    },
    billingPo: {
        required: true,
        minLength: 2,
        label: "PO",
    },
    paymentMethodSelect: {
        required: true,
        label: "Payment Type",
        requiredMsg: "Please Select Payment Type.",
    },
};
